import { createPortal } from "react-dom";

import { Button } from "@transfr-inc/dashboard-components/forms";

import {
  DeviceTagsModalSlides,
  ManageDeviceTagsModal,
} from "@components/modals";

export const ManageTagsButton = ({
  organizationCode,
  open,
  initialSlide = DeviceTagsModalSlides.LIST,
  onOpen,
  onClose,
}) => {
  return (
    <>
      <Button
        icon={["fa-regular", "tags"]}
        onClick={onOpen}
        disabled={!organizationCode}
      >
        Manage Tags
      </Button>
      {createPortal(
        <ManageDeviceTagsModal
          key={initialSlide}
          open={open}
          onClose={onClose}
          organizationCode={organizationCode}
          initialSlide={initialSlide}
        />,
        document.body
      )}
    </>
  );
};
